<template>
    <div class="container _container">
      <div class="containerbody _containerbody">
        <div class="content _content">
          <!-- <div style="font-size: 14px;text-align: left;margin-bottom: 8px" >
            <i class="el-icon-s-home"></i>
            <span>
            {{ titleData.title }}>>
              <span @click="subTitleClick(activeIndex)" class="activeIndex" style="cursor: pointer;" v-if="titleData.children!=null">{{titleData.children[activeIndex].title}}>></span>
                <span style="color: #95c5ff;">{{ this.contentData.title}}</span>
          </span>
          </div> -->
          <!-- <el-page-header @back="goBack" content="详情页面" style="margin-bottom: 1em;">
          </el-page-header> -->
          <div style="float: left;height: 2em;align-items: center;display: flex;width: 100%;margin-bottom: 1em;">
            <div style="display: flex;width: 4.5em;border-right: 1px solid #DCDFE6;cursor: pointer; " @click="goBack"><i class="el-icon-back" style="font-size: 18px;"></i><div style="font-size: 0.9em;margin-left: 0.4em;">{{$t('home.back')}}</div></div>
            <div style="margin-left: 1.1em;font-size: 18px;">{{$t('home.detailPage')}}</div>
          </div>
          <!-- <div class="content_left">
            <el-card>
              <div class="sideBar">
                <div class="head_title">{{ titleData.title }}</div>
                <div class="divide_line"></div>
                <div v-for="(item,index) in titleData.children" :key="index"
                     :class="index == activeIndex?'navActive':'nav'" @click="subTitleClick(index)">{{ item.title }}
                </div>

              </div>
            </el-card>
          </div> -->
          <div class="content_right _content_right">
            <div style="width: 100%;background-color: #ffffff;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);border-radius: 5px;">

              <div class="message_all _message_all">
                <div :class="$route.query.personStatus == 1?'message_head_red _message_head_red':'message_head_yellow _message_head_yellow'" >
                            <img :src="imageUrl" width="auto" height="80%" style="margin-left: 5%;border:5px solid #ffffff;background-color: #ffffff;" v-if="windowWidth<800"/>

                            <div class="message_name _message_name">
                              {{$t('home.caseNumber')}}  {{contentData.personNum}}
                            </div>
                </div>
                <el-row v-if="windowWidth>=800">
                    <el-col :span="6">
                        <div style="background-color: #ffffff;">
                            <img :src="imageUrl" width="180em" height="auto" style="margin-top: -8em;border:5px solid #ffffff;background-color: #ffffff;" />
                        </div>
                        <div class="message_content_left _message_content_left">
                            <div class="message_object _message_object">
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personSex}}
                                </div>
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.sex')}}
                                </div>
                            </div>

                        </div>

                    </el-col>
                    <el-col :span="18" style="background-color: #F3F3F3;height: 100%;">
                        <div class="message_content_right _message_content_right">

                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.name')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personName}}
                                </div>

                            </div>
                            <div class="message_object _message_object">

                                <div class="message_object_name _message_object_name">
                                  {{$t('home.nationality')}}
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personNationality}}
                                </div>
                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.birthAddress')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personBirthAddress}}
                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.birthDay')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personBirthday}}

                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.description')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personDescription}}

                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.trait')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personTrait}}

                                </div>

                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="windowWidth<800">
                    <!-- <el-col :span="6">
                        <div style="background-color: #ffffff;">
                            <img :src="imageUrl" width="180em" height="auto" style="margin-top: -8em;border:5px solid #ffffff;background-color: #ffffff;" />
                        </div>
                        <div class="message_content_left _message_content_left">
                            <div class="message_object _message_object">
                                <div class="message_object_content _message_object_content">
                                  {{contentData.sex}}
                                </div>
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.sex')}}
                                </div>
                            </div>

                        </div>

                    </el-col> -->
                    <el-col :span="24" style="height: 100%;">
                        <div class="message_content_right _message_content_right">
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.name')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.name}}
                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.sex')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.personSex}}
                                </div>

                            </div>
                            <div class="message_object _message_object">

                                <div class="message_object_name _message_object_name">
                                  {{$t('home.nationality')}}
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.nationality}}
                                </div>
                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.birthAddress')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.birthAddress}}
                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.birthDay')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.birthday}}

                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.description')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.description}}

                                </div>

                            </div>
                            <div class="message_object _message_object">
                                <div class="message_object_name _message_object_name">
                                  {{$t('home.trait')}}:
                                </div>
                                <div class="message_object_content _message_object_content">
                                  {{contentData.trait}}

                                </div>

                            </div>
                        </div>
                    </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import {getContentDetail} from '@/api/detail'
  import {getPersonRedYellowList} from '@/api/personRedYellow'
  export default {
    name: 'aboutUs',
    components: {},
    data() {
      return {
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        imageUrl: this.$route.query.personStatus ==1?require('../../assets/img/red.png'):require('../../assets/img/yellow.png'),
        imageUrl2: require('@/components/aboutUs/imgs/Twitter.png'),
        imageUrl3: require('@/components/aboutUs/imgs/contentPhoto.png'),
        contentData: {},
        detailId: this.$route.query.detailId,
        // pid: this.$route.query.pid,
        id: this.$route.query.id,
        titleData: {},//标题内容
        titleTree: JSON.parse(sessionStorage.getItem('titleTree')),
        activeIndex: 0,
        showPiclist: false,
        imageList:[
          {src:require('@/components/aboutUs/imgs/facebook.png'),url:"https://www.facebook.com/"},
          {src:require('@/components/aboutUs/imgs/Twitter.png'),url:"http://www.x.com/"},
        ],
        dataList:[{number:'',name:''}],
        dataListZh:[
            {
                plugImage:'../../assets/img/red.png',
                number:'0000001',
                name:'XX',
                sex:'男',
                nationality:"中国",
                birthAddress:'中国',
                birthday:"1987年3月29日(现37岁)",
                description:"所使用语言为中文",
                trait:"身穿白色t恤,戴深色帽子",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000002',
                name:'XXX',
                sex:'男',
                nationality:"中国",
                birthAddress:'中国',
                birthday:"1977年5月29日(现47岁)",
                description:"所使用语言为中文",
                trait:"身穿黄色t恤,戴白色帽子",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000003',
                name:'XXX',
                sex:'女',
                nationality:"越南",
                birthAddress:'越南',
                birthday:"1997年6月20日(现27岁)",
                description:"所使用语言为越南语",
                trait:"身穿绿色上衣,深色裤子",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000004',
                name:'XX',
                sex:'男',
                nationality:"中国",
                birthAddress:'中国',
                birthday:"1987年3月29日(现37岁)",
                description:"所使用语言为中文",
                trait:"身穿白色t恤,戴深色帽子",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000005',
                name:'XXX',
                sex:'男',
                nationality:"中国",
                birthAddress:'中国',
                birthday:"1987年3月29日(现37岁)",
                description:"所使用语言为中文",
                trait:"身穿白色t恤,戴深色帽子",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000006',
                name:'XX',
                sex:'男',
                nationality:"中国",
                birthAddress:'中国',
                birthday:"1987年3月29日(现37岁)",
                description:"所使用语言为中文",
                trait:"身穿白色t恤,戴深色帽子",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000007',
                name:'XX',
                sex:'女',
                nationality:"泰国",
                birthAddress:'泰国',
                birthday:"2000年6月19日(现24岁)",
                description:"所使用语言为泰语",
                trait:"身穿红色上衣",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000008',
                name:'XX',
                sex:'男',
                nationality:"中国",
                birthAddress:'中国',
                birthday:"1987年3月29日(现37岁)",
                description:"所使用语言为中文",
                trait:"身穿白色t恤,戴深色帽子",
            },
        ],
        dataListEn:[
            {
                plugImage:'../../assets/img/red.png',
                number:'0000001',
                name:'XX',
                sex:'Male',
                nationality:"China",
                birthAddress:'China',
                birthday:"29/03/1987 (37 years old)",
                description:"Language spoken is Chinese",
                trait:"Wearing a white t-shirt and a dark hat",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000002',
                name:'XX',
                sex:'Male',
                nationality:"China",
                birthAddress:'China',
                birthday:"29/05/1977 (47 years old)",
                description:"Language spoken is Chinese",
                trait:"Wearing a yellow t-shirt and a white hat",

            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000003',
                name:'XX',
                sex:'Female',
                nationality:"Vietnam",
                birthAddress:'Vietnam',
                birthday:"20/06/1997 (27 years old)",
                description:"Language spoken is vietnamese",
                trait:"Wearing a green shirt and dark pants",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000004',
                name:'XX',
                sex:'Male',
                nationality:"China",
                birthAddress:'China',
                birthday:"29/03/1987 (37 years old)",
                description:"Language spoken is Chinese",
                trait:"Wearing a white t-shirt and a dark hat",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000005',
                name:'XX',
                sex:'Male',
                nationality:"China",
                birthAddress:'China',
                birthday:"29/03/1987 (37 years old)",
                description:"Language spoken is Chinese",
                trait:"Wearing a white t-shirt and a dark hat",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000006',
                name:'XX',
                sex:'Male',
                nationality:"China",
                birthAddress:'China',
                birthday:"29/03/1987 (37 years old)",
                description:"Language spoken is Chinese",
                trait:"Wearing a white t-shirt and a dark hat",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000007',
                name:'XX',
                sex:'Female',
                nationality:"Thailand",
                birthAddress:'Thailand',
                birthday:"19/06/2000 (24 years old)",
                description:"Language spoken is Thai",
                trait:"Wearing a red shirt",
            },
            {
                plugImage:'../../assets/img/red.png',
                number:'0000008',
                name:'XX',
                sex:'Male',
                nationality:"China",
                birthAddress:'China',
                birthday:"29/03/1987 (37 years old)",
                description:"Language spoken is Chinese",
                trait:"Wearing a white t-shirt and a dark hat",
            },
        ],
        queryParams:{}
      }
    },
    mounted() {
      // this.init()
      this.getData()
    },

    methods: {
      init() {
        let that=this;
        getContentDetail({id: this.detailId}).then(res => {
          if (res.data.Img) {
            res.data.Img = res.data.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
          }
          if (res.data.content) {
            res.data.content = res.data.content.replace(/\/upload/g, `${this.$urlFile}/upload`);
          }
          if (res.data.piclist!=null&&res.data.piclist!="" && res.data.piclist!="NULL"){
            res.data.piclist = res.data.piclist.replace(/\/upload/g, `${this.$urlFile}/upload`);
            // 将res.data.piclist按照’|‘进行分割
            res.data.piclist = res.data.piclist.split('|');
            this.showPiclist = true
          }
          this.contentData = res.data
        })

        this.titleTree.children.forEach((item, index) => {
          if (item.data.id == this.pid) {
            this.titleData = item

            // this.queryParams.classId = this.id
            item.children.forEach((item2, index2) => {

              if (item2.data.id == this.id) {

                this.activeIndex = index2
              }
            })
          }else{
            if(item.children!=null){
              item.children.forEach((it,ind)=>{
                if(it.data.id==that.pid){
                  that.titleData = it
                  it.children.forEach((it2, ind2) => {
                    if (it2.data.id == that.id) {
                      that.activeIndex = ind2
                    }
                  })
                }
              })
            }
          }
        });
      },
      getData(){
        if(this.$i18n.locale == 'zh'){
                this.queryParams.lang="1"
            }else{
                this.queryParams.lang="2"
            }
        getPersonRedYellowList(this.queryParams).then(res => {
            this.dataList = res.data;
            this.dataList.forEach((item,index)=>{
            if(this.id === item.id){
              this.contentData = item
              console.log("item11",item)
              }
            })
        })
        
        // if(this.$i18n.locale == 'zh'){
        //     this.queryParams.lang="1"
        //     this.dataListZh.forEach((item,index)=>{
        //       if(this.id === item.number){
        //         this.contentData = item
        //       }
        //     })
        //   }else{
        //     this.queryParams.lang="2"
        //     this.dataListEn.forEach((item,index)=>{
        //       if(this.id == item.number){
        //         this.contentData = item
        //       }
        //     })
        //   }
      },
      shareClick() {
        this.$refs.shareDialog.open('Repost to Facebook', {})

      },
      subTitleClick(index) {
        this.$router.push({
          path: '/navigation',
          query: {
            pid: this.pid,
            id: this.titleData.children[index].data.id,
            // isThirdLevel: true,
          }
        })
      },
      imgTagAddStyle (htmlstr) {
        if(htmlstr !="" &&htmlstr != null &&htmlstr !=undefined){
          let newContent = htmlstr.replace(/<img[^>]*>/gi, function (match, capture) {
          match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
          match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
          match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
          return match
        })
        newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
          match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;')
          match = match.replace(/font-family:[^;]+;/gi, 'font-family:Arial,\'AKbalthom Freedom Plus\',\'微软雅黑\',SimHei').replace(/font-family:[^;]+;/gi, 'font-family:Arial,\'AKbalthom Freedom Plus\',\'微软雅黑\',SimHei')
          match = match.replace(/font-size:[^;]+;/gi, '').replace(/font-size:[^;]+;/gi, '')
          return match
        })
        newContent = newContent.replace(/<br[^>]*\/>/gi, '')
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:inline-block;margin:8px 0;"')
        return newContent
        }

      },
      goBack(){
        this.$router.push({
                path: '/personNotice',
                query: {
                    personStatus:this.$route.query.personStatus
                }
            })
      },
    }
  }
  </script>

  <style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px) {
    .container {
      width: 100%;
      overflow: hidden;


      .containerbody {
        width: 100%;
        min-height: 55.5vh;
        // max-width:1000px ;
        background-color: rgb(249, 249, 249);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;

        .content {
          width: 80%;
          margin: 0 auto;

          .content_left {
            width: 16%;
            float: left;

            .sideBar {
              text-align: left;
              width: 100%;

              .head_title {
                padding: 0 0 20px 0;
                color: rgba(51, 51, 51, 1);
                font-family: SourceHanSansCN-Bold;
                font-weight: 700;
                font-size: 18px;
                font-weight: bold;
              }

              .sub_title {
                padding: 4px 0;
                color: rgba(51, 51, 51, 1);
                font-family: SourceHanSansCN-Regular;
                font-size: 12px;

              }

              .divide_line {
                width: 90%;
                height: 1.5px;
                margin: 4px 0;
                background-color: #2D52D0;
              }

              .nav {
                overflow-wrap: break-word;
                color: rgba(110, 110, 115, 1);
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .nav:hover {
                overflow-wrap: break-word;
                color: #2D52D0;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .navActive {
                overflow-wrap: break-word;
                color: #2D52D0;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }

          .content_right {
            width: 100%;
            float: right;
            // margin-left: 3%;
            .message_all{
                width: 100%;
                .message_head_red{
                    width: 100%;
                    height:12em;
                    background-color: #FD6F6A;
                    // margin:-20px -20px;
                    display: flex;
                    justify-content: flex-end;
                    .message_name{
                        color: #ffffff;
                        width: 75%;
                        // float: right;
                        font-size: 2.5em;
                        font-weight: bold;
                        text-align: left;
                        padding-top: 2em;
                        // padding-left: 8.6em;

                    }
                }
                .message_head_yellow{
                    width: 100%;
                    height:12em;
                    background-color: #F3D43E;
                    // margin:-20px -20px;
                    display: flex;
                    justify-content: flex-end;
                    .message_name{
                        color: #ffffff;
                        width: 75%;
                        // float: right;
                        font-size: 2.5em;
                        font-weight: bold;
                        text-align: left;
                        padding-top: 2em;
                        // padding-left: 8.6em;

                    }
                }
                .message_img{
                    max-width: 8em;
                    height: auto;
                    background-image:url(../../assets/img/person_img1.jpg);
                    background-size: 100% 100%;
                    margin:0 auto;
                }
                .message_content_left{
                    // width: 8em;
                    // margin:2% 0 2% 5em;
                    justify-content: center;
                    .message_object{
                        // display: flex
                        text-align: center;
                        margin:2em 0;
                        .message_object_name{
                            width: 100%;
                            font-size: 1.2em;
                            text-align: center;
                            margin:0.6em 0;
                        }
                        .message_object_content{
                            width: 100%;
                            font-size: 1.2em;
                            font-weight: bold;
                            text-align: center;
                            margin:0.6em 0;
                        }
                    }
                }
                .message_content_right{
                    width: 90%;
                    margin:2% auto;
                    text-align: left;
                    .message_object{
                        display: flex;
                        margin:2em 0;
                        .message_object_name{
                            width: 20%;
                            font-size: 1.2em;
                            text-align: left;
                            margin:0.6em 0;
                        }
                        .message_object_content{
                            width: 80%;
                            font-size: 1.2em;
                            font-weight: bold;
                            text-align: left;
                            margin:0.6em 0;
                        }
                    }
                }
            }
            ::v-deep {
      img {
        width: 100%;
      }
    }
            .text_img {
              width: 100%;
              // padding: 0 0%;
              margin: 20px 0 20px 0;
              // height: 400px;
            }

            .share_box {
              height: 100px;
              float: right;
              margin-top: 50px;

              .share_img {
                float: left;
                margin: 4px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    ._container {
      width: 100%;
      overflow: hidden;


      ._containerbody {
        width: 100%;
        min-height: 55.5vh;
        // max-width:1000px ;
        background-color: rgb(249, 249, 249);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;

        ._content {
          width: 98%;
          margin: 0 auto;

          ._content_left {
            width: 16%;
            float: left;

            ._sideBar {
              text-align: left;
              width: 100%;

              ._head_title {
                padding: 0 0 20px 0;
                color: rgba(51, 51, 51, 1);
                font-family: SourceHanSansCN-Bold;
                font-weight: 700;
                font-size: 18px;
                font-weight: bold;
              }

              ._sub_title {
                padding: 4px 0;
                color: rgba(51, 51, 51, 1);
                font-family: SourceHanSansCN-Regular;
                font-size: 12px;

              }

              ._divide_line {
                width: 90%;
                height: 1.5px;
                margin: 4px 0;
                background-color: #2D52D0;
              }

              ._nav {
                overflow-wrap: break-word;
                color: rgba(110, 110, 115, 1);
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              ._nav:hover {
                overflow-wrap: break-word;
                color: #2D52D0;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              ._navActive {
                overflow-wrap: break-word;
                color: #2D52D0;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: normal;
                white-space: nowrap;
                line-height: 24px;
                margin: 15px 0 10px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }

          ._content_right {
            width: 100%;
            float: right;
            // margin-left: 3%;
            ._message_all{
                width: 100%;
                ._message_head_red{
                    width: 100%;
                    height:8em;
                    background-color: #FD6F6A;
                    // margin:-20px -20px;
                    display: flex;
                    // justify-content: flex-end;
                    align-items: center;
                    ._message_name{
                        color: #ffffff;
                        width: 75%;
                        // float: right;
                        font-size: 22px;
                        font-weight: bold;
                        text-align: left;
                        padding-left: 1em;
                        // padding-top: 2em;
                        // padding-left: 8.6em;

                    }
                }
                ._message_head_yellow{
                    width: 100%;
                    height:8em;
                    background-color: #F3D43E;
                    // margin:-20px -20px;
                    display: flex;
                    // justify-content: flex-end;
                    align-items: center;
                    ._message_name{
                        color: #ffffff;
                        width: 75%;
                        // float: right;
                        font-size: 22px;
                        font-weight: bold;
                        text-align: left;
                        padding-left: 1em;
                        // padding-top: 2em;
                        // padding-left: 8.6em;

                    }
                }
                ._message_img{
                    max-width: 8em;
                    height: auto;
                    background-image:url(../../assets/img/person_img1.jpg);
                    background-size: 100% 100%;
                    margin:0 auto;
                }
                ._message_content_left{
                    // width: 8em;
                    // margin:2% 0 2% 5em;
                    justify-content: center;
                    ._message_object{
                        // display: flex
                        text-align: center;
                        margin:2em 0;
                        ._message_object_name{
                            width: 100%;
                            font-size: 12px;
                            text-align: center;
                            margin:0.6em 0;
                        }
                        ._message_object_content{
                            width: 100%;
                            font-size: 12px;
                            // font-weight: bold;
                            text-align: center;
                            margin:0.6em 0;
                        }
                    }
                }
                ._message_content_right{
                    width: 90%;
                    margin:2% auto;
                    text-align: left;
                    ._message_object{
                        display: flex;
                        margin:2em 0;
                        ._message_object_name{
                            min-width: 20%;
                            font-size: 20px;
                            text-align: left;
                            margin:0.6em 0;
                        }
                        ._message_object_content{
                            // width: 80%;
                            font-size: 20px;
                            font-weight: bold;
                            text-align: left;
                            margin:0.6em 0;
                        }
                    }
                }
            }
            ::v-deep {
      img {
        width: 100%;
      }
    }
            ._text_img {
              width: 100%;
              // padding: 0 0%;
              margin: 20px 0 20px 0;
              // height: 400px;
            }

            ._share_box {
              height: 100px;
              float: right;
              margin-top: 50px;

              ._share_img {
                float: left;
                margin: 4px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
  .activeIndex:hover{
    color: #95c5ff;
  }
  </style>



// WEBPACK FOOTER //
// src/components/page/personDetail.vue